import * as Factory from 'factory.ts'
import faker from 'faker'

import { InboxMessageMock } from './inboxMessage.factory'

export const CommentMock = InboxMessageMock
